module.exports = __webpack_public_path__ + "media/flags/sb-9dfcf0dd.svg";